import { QueryParams } from 'common/urls/QueryParams';
import React from 'react';
import { MerchandisingTag } from 'src/gqlReactTypings.generated.d';
import { useTasteProfileFiltersStoreSelectors } from 'src/ztore/taste-profile-filters-store';
import { StringParam, useQueryParam } from 'use-query-params';
import Chip, { ChipColor } from 'web-common/src/shared/design-system/components/Chip';
import { MERCHANDISING_TAG_MAPPINGS } from '../../consts';

interface MerchandisingTagChipProps {
  merchandisingTags: MerchandisingTag[];
  showNewFreshTag?: boolean;
}

// All seasonal tags are visible; the backend already returns at most one seasonal tag
// per dish, matched to the delivery date the customer is browsing.
const VISIBLE_MERCHANDISING_TAGS: MerchandisingTag[] = [
  MerchandisingTag.LimitedTime,
  MerchandisingTag.SpringFavorites,
  MerchandisingTag.SummerFavorites,
  MerchandisingTag.FallFavorites,
  MerchandisingTag.WinterFavorites,
  MerchandisingTag.NewFresh,
];

export const MerchandisingTagChip: React.FC<MerchandisingTagChipProps> = ({
  merchandisingTags,
  showNewFreshTag = true,
}) => {
  const [tab] = useQueryParam(QueryParams.TAB, StringParam);
  const isForYouPage = tab === 'FOR_YOU';
  const selectedMerchandisingTag = useTasteProfileFiltersStoreSelectors.use.selectedMerchandisingTag();

  const visibleMerchandisingTags = merchandisingTags.filter((tag) => {
    if (!VISIBLE_MERCHANDISING_TAGS.includes(tag)) return false;
    if (tag === MerchandisingTag.NewFresh && !showNewFreshTag) return false;
    return true;
  });
  if (visibleMerchandisingTags.length === 0 || isForYouPage) {
    return null;
  }

  // If the user has filtered by a merch pill, prefer surfacing that tag on every dish in the
  // result set — it makes the active filter visible at a glance even if the dish has a
  // higher-priority tag (e.g. user picks "Low calorie" but the dish is also "New & fresh").
  const tagToShow =
    selectedMerchandisingTag && visibleMerchandisingTags.includes(selectedMerchandisingTag)
      ? selectedMerchandisingTag
      : visibleMerchandisingTags[0];

  const tag = MERCHANDISING_TAG_MAPPINGS[tagToShow];
  if (!tag) {
    return null;
  }

  return <Chip color={ChipColor.RICE} copy={tag} />;
};
